<template>
	<div>
		<div v-if="vModel.PaymentMethodId == 2">
			<div class="main-header">
				<div class="container">
					<h2 class="main-header-text">Refund Details</h2>
				</div>
			</div>
			<div class="main-section mgt-40">
				<div class="container">
					<div class="main-card">
						<img src="/static/img/icons/arrow-down-indicator-red.png" alt class="top-indicator" />

						<div>
							<div class="form-card">
								<div class="form-card-header">
									<h3>Refund Details</h3>
								</div>
								<div class="form-card-forms">
									<div class="col-md-12">
										<p>Note:</p>
										<p>Refunded amount will be credited to your Merchantrade Money Wallet within 2 -
											3 working days.</p>
									</div>
								</div>
								<div class="center-align">
									<div class="row">
										<div class="col-md-6">
											<label>Transaction Id:</label>
										</div>
										<div class="col-md-6">{{RefundViewModel.TransactionRefNo}}</div>
									</div>
									<div class="row">
										<div class="col-md-6">
											<label>Phone Number:</label>
										</div>
										<div class="col-md-6 text-bold">{{vModel.PhoneNumber}}</div>
									</div>
									<div class="row">
										<div class="col-md-6">
											<label>MMoney Transaction ID:</label>
										</div>
										<div class="col-md-6 text-bold">{{vModel.MMoneyTransactionId}}</div>
									</div>
									<div class="row">
										<div class="col-md-6">
											<label>Refund Reason:</label>
										</div>
										<div class="col-md-6 text-bold">{{vModel.Beneficiary.ReasonRemark}}</div>
									</div>
								</div>
								<div style="text-align: center;padding-bottom: 8px">
									<button type="button" class="btn btn-danger" @click="onRefundMmoney">Done</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="main-header">
				<div class="container">
					<h2 class="main-header-text">Transaction Refund</h2>
				</div>
			</div>
			<!-- eo main header -->
			<div class="main-section mgt-40">
				<div class="container">
					<div class="main-card">
						<img src="/static/img/icons/arrow-down-indicator-red.png" alt class="top-indicator" />
						<div class="row">
							<div class="col-lg-8">
								<div class="form-card">
									<div class="form-card-header">
										<h3>Refund Reason</h3>
									</div>
									<div class="form-card-forms refund">
										<h4>{{vModel.Beneficiary.ReasonRemark}}</h4>
										<p class="m-t-md" v-if="!vModel.IsServiceCharge">
											*Note – If you choose refund,
											the service charge will be non-refundable and the process will take up to
											three (3) working days.
										</p>
										<p class="m-t-md" v-if="vModel.IsServiceCharge">
											*Note – If you choose refund,the
											process will take up to three (3) working days.
										</p>
									</div>
									<!-- eo form card forms -->
								</div>
								<form @submit.prevent="onRefundSubmit" novalidate autocomplete="off">
									<!-- eo form card -->
									<div class="form-card">
										<div class="form-card-header">
											<h3>Bank Details</h3>
										</div>
										<div class="form-card-forms">
											<div class="row">
												<div class="col-12">
													<div class="form-group">
														<label for>
															Account Holder Name
															<span class="required">*</span>
														</label>
														<div class="row">
															<div class="col-lg-6">
																<input autocomplete="off"
																	v-model="RefundViewModel.AccountHolder" type="text"
																	class="form-control text-uppercase"
																	name="AccountHolder" data-vv-as="Account holder"
																	:class="{'input': true, 'is-danger': errors.has('AccountHolder') }"
																	v-validate="'required'" />
																<div v-show="errors.has('AccountHolder')"
																	class="help is-danger">
																	{{ errors.first('AccountHolder') }}</div>
															</div>
														</div>
													</div>
													<!-- eo form group -->
												</div>
												<!-- eo col -->
											</div>
											<!-- eo row -->
											<div class="row">
												<div class="col-lg-6">
													<div class="form-group">
														<label for>
															Bank Name
															<span class="required">*</span>
														</label>
														<kendo-dropdownlist name="BankId" v-if="Banks!=null"
															class="form-control" v-model="RefundViewModel.BankId"
															:data-text-field="'Name'" :data-value-field="'Id'"
															:option-label="'Please Select Bank'" :auto-bind="true"
															:data-source="Banks" :data-value-primitive="true"
															@select="onSelect" @change="onChange"></kendo-dropdownlist>

														<input v-model="RefundViewModel.BankId" type="hidden"
															name="BankName" data-vv-as="Bank"
															:class="{'input': true, 'is-danger': errors.has('BankName') }"
															v-validate="'required'" />

														<div v-show="errors.has('BankName')" class="help is-danger">
															{{ errors.first('BankName') }}</div>
													</div>
													<!-- eo form group -->
												</div>
												<!-- eo col -->
											</div>
											<!-- eo row -->

											<div class="row">
												<div class="col-lg-6">
													<div class="form-group">
														<label for>
															Bank Account Number
															<span class="required">*</span>
														</label>
														<input autocomplete="off"
															v-model="RefundViewModel.AccountNumber" type="text"
															class="form-control text-uppercase" name="AccountNumber"
															:class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
															v-validate="accountRequired" v-only-uppercase />
														<div v-show="errors.has('AccountNumber')"
															class="help is-danger">{{ errors.first('AccountNumber') }}
														</div>
													</div>
													<!-- eo form group -->
												</div>
												<!-- eo col -->
											</div>
											<!-- eo row -->
										</div>
										<!-- eo form card forms -->
									</div>
									<!-- eo form card -->

									<div class="submit-option">
										<div class="left-option">
											<router-link :to="'/transaction'" class="btn submit-lefticon-btn">
												<span class="left-icon">
													<i class="fas fa-angle-left"></i>
												</span>
												<span class="btn-content">Cancel</span>
											</router-link>
										</div>

										<div class="right-option">
											<button class="btn submit-righticon-btn">
												<span class="btn-content">Refund</span>
												<span class="right-icon">
													<i class="fas fa-angle-right"></i>
												</span>
											</button>
										</div>
									</div>
								</form>
							</div>
							<!-- eo col-8 -->

							<div class="col-lg-4">
								<div class="sidebar">
									<img src="/static/img/icons/arrow-down-indicator-white.png" alt
										class="sidebar-arrow" />
									<h3 class="sidebar-header">Transfer Summary</h3>
									<hr />
									<!-- <UserCountrySection/> -->
									<div class="country-detail">
										<img :src="'/static/img/flags/'+vModel.Beneficiary.FlagCode+'.png'" alt />
										<h4>
											{{vModel.Beneficiary.FullName}}
											<br />
											<span class="country">{{vModel.Beneficiary.Country}}</span>
										</h4>
									</div>
									<hr />
									<div class="personal-detail">
										<ul>
											<li v-if="vModel.PaymodeId == 101">
												<p>Payment Network : </p>
												<h4>Visa</h4>
											</li>
											<li v-else-if="vModel.PaymodeId == 97 || vModel.PaymodeId == 98">
												<p>Payment Network : </p>
												<h4>Western Union</h4>
											</li>
											<li v-else>
												<p>Payment Network : </p>
												<h4>Merchantrade</h4>
											</li>
											<li>
												<p>Payment Mode :</p>
												<h4>
													{{
														vModel.PaymodeId == 1 ? "Bank Account" :
														(vModel.PaymodeId == 2) ? "Cash Pickup" :
														(vModel.PaymodeId == 21) ? "Union Pay Card" :
														(vModel.PaymodeId == 22) ? "Alipay" :
														(vModel.PaymodeId == 23) ? "bKash" :
														(vModel.PaymodeId == 26) ? "MCB" :
														(vModel.PaymodeId == 24 || vModel.PaymodeId == 28 || vModel.PaymodeId == 29) ? "eWallet" :
														(vModel.PaymodeId == 27) ? "Weixin Wallet" :
														(vModel.PaymodeId == 30) ? "Nagad" :
														(vModel.PaymodeId == 31) ? "ESEWA Wallet" :
														(vModel.PaymodeId == 32) ? "AYA Wallet" :
														(vModel.PaymodeId == 33) ? "KBZPay Wallet" :
														(vModel.PaymodeId == 97) ? "Western Union: Cash Pickup" :
														(vModel.PaymodeId == 98) ? "Western Union: Bank Account" : vModel.PaymentModeName
													}}
												</h4>
											</li>
											<li v-if="vModel.PaymodeId == 1 && (vModel.Beneficiary.CountryId == 23 || vModel.Beneficiary.CountryId == 251 ||  vModel.Beneficiary.CountryId == 2) && vModel.Beneficiary.ReceiverType">
												<p>
													{{
												 "Receiver Type :"
													}}
												</p>
												<h4>
													{{vModel.Beneficiary.ReceiverType}}
												</h4>
											</li>
											<li>
												<p>
													{{
														vModel.PaymodeId == 1 ? "Bank Account Holder Name" :
														(vModel.PaymodeId == 2) ? "Beneficiary Name" :
														(vModel.PaymodeId == 27) ? "Wallet Holder Name" :
													    (vModel.PaymodeId == 30) ? "Wallet Holder Name" :
														(vModel.PaymodeId == 28 || vModel.PaymodeId == 29) ? "eWallet Holder Name" :
														(vModel.PaymodeId == 31 || vModel.PaymodeId == 32 || vModel.PaymodeId == 33) ? "Wallet Holder Name" :"Beneficiary Name"
													}}:
												</p>
												<h4>{{vModel.Beneficiary.FullName.toUpperCase()}}</h4>
											</li>
											<li v-if="vModel.OnBehalfCustomerDetail.OnBehalfCustomerId">
												<p>Beneficial Owner :</p>
												<h4>{{vModel.OnBehalfCustomerDetail.Name}}</h4>
											</li>
											<li v-if="vModel.PaymodeId == 1">
												<p>
													Bank Account Number :
												</p>
												<h4>{{vModel.Beneficiary.BankAccount}}</h4>
											</li>
											<li v-if="vModel.PaymodeId == 1">
												<p>Bank Name :</p>
												<h4>{{vModel.Beneficiary.Bank}}</h4>
											</li>
											<li v-if="vModel.PaymodeId == 24">
												<p>eWallet Type :</p>
												<h4>{{vModel.Beneficiary.Bank}}</h4>
											</li>
											<li v-if="vModel.PaymodeId == 28 || vModel.PaymodeId == 29">
												<p>eWallet Type :</p>
												<h4>{{vModel.Beneficiary.WalletType}}</h4>
											</li>
											<li v-if="vModel.PaymodeId == 28 || vModel.PaymodeId == 29">
												<p>eWallet Number :</p>
												<h4>{{vModel.Beneficiary.BankAccount}}</h4>
											</li>
											<li v-if="vModel.PaymodeId == 24">
												<p>eWallet Number :</p>
												<h4>{{vModel.Beneficiary.BankAccount}}</h4>
											</li>
											<li v-if="vModel.PaymodeId == 21">
												<p>Union Pay Card :</p>
												<h4>{{vModel.Beneficiary.BankAccount}}</h4>
											</li>
											<li v-if="vModel.PaymodeId == 22 || vModel.PaymodeId == 27 || vModel.PaymodeId == 31 || vModel.PaymodeId == 32 || vModel.PaymodeId == 33">
												<p>Wallet Number :</p>
												<h4>{{vModel.Beneficiary.BankAccount}}</h4>
											</li>											
											<li v-if="vModel.PaymodeId == 30">
												<p>Nagad Wallet Number :</p>
												<h4>{{vModel.Beneficiary.BankAccount}}</h4>
											</li>
											<li v-if="vModel.PaymodeId == 2 || vModel.PaymodeId == 34 || vModel.PaymodeId == 35">
												<p>Agent :</p>
												<h4>{{vModel.Beneficiary.Agent}}</h4>
											</li>
											<li v-if="vModel.PaymodeId == 97 || vModel.PaymodeId == 2">
												<p>Address :</p>
												<h4>{{vModel.Beneficiary.Address}}</h4>
											</li>
										</ul>
									</div>

									<hr />

									<div class="amount-detail">
										<ul>
											<li>
												Transfer Amount(MYR) :
												<span>{{vModel.SendAmount}}</span>
											</li>
											<li>
												Exchange Rate :
												<span>{{vModel.ExchangeRate}}</span>
											</li>
											<li>
												Receive Amount ({{vModel.PayoutCurrency}})
												:
												<span>{{vModel.PayoutAmount}}</span>
											</li>
											<li v-if="vModel.IsServiceCharge">
												Service Charge (MYR) :
												<span>{{vModel.TransferFee}}</span>
											</li>
											<li v-if="vModel.ShowGST">
												GST Charge (MYR) :
												<span>{{vModel.GST}}</span>
											</li>
											<li v-if="vModel.ShowPromoDiscount && vModel.IsServiceCharge">
												Promotion Discount (MYR) :
												<span>-{{vModel.PromotionDiscount}}</span>
											</li>
										</ul>
										<div class="total-detail">
											<p>Refund Amount (MYR) : {{vModel.RefundAmount}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- eo row -->
					</div>
					<!-- eo main card -->
				</div>
				<!-- eo container -->
			</div>
			<!-- eo main section -->
		</div>
	</div>
</template>
<script>
	import Base from "../../shared/Base.vue";
	import UserCountrySection from "../../shared/UserCountrySection.vue";
	import Action from "../../shared/Action.vue";
	import Mode from "../../shared/Mode.vue";
	import { vueinstance } from "../../main";
	import authservice from "../../services/authservice";
	import ListService from "../../services/list";

	export default {
		name: "transactionotp",
		extends: Base,
		components: {
			Action,
			Mode,
			UserCountrySection
		},
		created() { },
		beforeRouteEnter(to, from, next) {
			var promises = [];

			promises.push(
				ListService.get("transaction/detail/" + to.params.id),
				ListService.getCountry(),
				ListService.get("list/getallrefundbank")
			);

			Promise.all(promises).then(response => {
				next(p => {
					p.RefundViewModel.TransactionRefNo = to.params.id;
					p.vModel = response[0].body;
					p.CountryCollection = response[1].body;
					p.Banks = response[2].body;
					p.RefundViewModel.RefundRemark = response[0].body.Remark;
				});
			});
		},
		data() {
			return {
				CountryCollection: null,
				Banks: null,
				RefundViewModel: {
					TransactionRefNo: "",
					AccountNumber: null,
					AccountHolder: null,
					BankId: null,
					RefundRemark: null
				},
				RangeFrom: null,
				RangeTo: null,
				accountRequired: "required",
				vModel: {
					PayoutAmount: null,
					SendAmount: null,
					SenderName: null,
					SenderAddress: null,
					BonusLinkCardNumber: null,
					IsBonusLinkCardNeeded: null,
					TransactionRefNumber: null,
					CreditNoteNumber: null,
					CreatedDate: null,
					TransactionStatus: null,
					IsReprocess: null,
					IsRefundEnabled: null,
					PaymodeId: null,
					Remark: null,
					SourceOfFund: null,
					PaymentPurpose: null,
					ExchangeRate: null,
					TransferFee: null,
					GST: null,
					ShowGST: true,
					DepositedAmount: null,
					PaymentProgressComment: null,
					GSTPercentage: null,
					PayoutCurrency: null,
					FPXNumber: null,
					Beneficiary: {
						Id: null,
						FullName: "",
						Address: null,
						CountryCode: null,
						Country: null,
						Currency: null,
						City: null,
						Street: null,
						PostCode: null,
						State: null,
						Bank: null,
						Branch: null,
						BankAccount: null,
						Agent: null,
						CashPickupPin: null,
						PickupLocation: null,
						ReasonRemark: null,
						RefundAmount: null,
						FlagCode: null,
						IsBonusLinkCardNeeded: null,
						BonusLink: null,
						PhoneNumber: null,
						Relation: null,
						BankOrAgent: null
					},
					OnBehalfCustomerDetail: {
						OnBehalfCustomerId: null,
						Name: null,
						IdNumber: null
					},
					PaymentReference: null,
					OldTransactionRefNumber: null,
					IsServiceCharge: false,
					RefundAmount: null,
					CompanyName: null,
					CompanyAddress: null,
					IsCreditNote: null,
					TypeofTraxId: null,
					StatusId: null,
					PaymentMethodId: null,
					MMoneyTransactionId: null,
					PhoneNumber: null
				}
			};
		},
		methods: {
			onRefundSubmit: function () {
				var self = this;
				if (self.isProcessing) return;

				self.$validator.validateAll().then(result => {
					if (result) {
						self.isProcessing = true;
						self.$http
							.post("transaction/refund/process", self.RefundViewModel)
							.then(
								response => {
									self.$toastr("success", "Refund successfully");
									self.$router.push("/transaction");
								},
								error => {
									self.isProcessing = false;
								}
							);
					}
				});
			},

			onRefundMmoney: function () {
				var self = this;
				if (self.isProcessing) return;

				self.isProcessing = true;
				self.$http.post("transaction/refund/process", self.RefundViewModel).then(
					response => {
						self.$toastr("success", "Refund successfully");
						self.$router.push("/transaction");
					},
					error => {
						self.isProcessing = false;
					}
				);
			},
			onSelect(e) {
				if (this.vModel.BankId == e.dataItem.Id) {
					return false;
				}

				if (e.dataItem.RangeFrom && e.dataItem.RangeTo) {
					this.accountRequired = `required|min:${e.dataItem.RangeFrom}|max:${e.dataItem.RangeTo}`;
				} else {
					this.accountRequired = "required";
				}
			}
		}
	};
</script>
<style scoped>
	.center-align {
		max-width: 500px;
		margin: 0 auto;
		margin-top: 15px;
	}
</style>
